// extracted by css-extract-rspack-plugin
export default {"root":"prKxRAnNnM_oV9yI"};